<template>
  <div class="card mb-25 border-0 rounded-0 welcome-lms-courses-box">
    <div
      class="card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing"
    >
      <div class="row align-items-center">
        <div class="col-xxl-6">
          <div class="content">
            <span class="d-block fw-bold mb-5" id="current-date">
              {{ formattedDate }}
            </span>
            <h2 class="fw-semibold mb-8 text-white">
              Welcome Back 
              <span class="fw-bold text-white" v-if="userData">
                <template v-if="userData.first_name">{{ userData.first_name }}</template>
                <template v-else>{{ userData.username }}</template>!
              </span>
            </h2>
            <p class="fs-md-15 fs-lg-16">
              See what’s happening at a glance!
            </p>
            <div class="row list justify-content-center">
              <div
                class="col-lg-4 col-6 col-sm-4"
                v-for="update in updates"
                :key="update.id"
              >
                <div :class="['p-15 mt-15', update.bgClass]">
                  <span
                    class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
                  >
                    {{ update.title }}
                  </span>
                  <h4 :class="['mb-0 fw-black', update.class]">
                    {{ update.number }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-6 text-center text-xxl-end mt-15 mt-md-0">
          <img
            src="../../assets/images/welcome/welcome3.png"
            class="main-image"
            alt="welcome-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, onMounted} from "vue";
import { useUserStore } from '@/stores/userStore';


export default defineComponent({
  name: "WidgetHeader",
  data() {
    return {
      updates: [
        {
          id: 1,
          bgClass: "bg-f2f1f9",
          title: "Total Companies",
          class: "text-primary",
          number: "10000",
        },
        {
          id: 2,
          bgClass: "bg-faf7f7",
          title: "Filter MATCHES",
          class: "text-success",
          number: "550",
        },
        {
          id: 3,
          bgClass: "bg-ecf3f2",
          title: "HOURS SAVED",
          class: "text-danger",
          number: "300",
        },
      ],
    };
  },
  setup() {
    const userStore = useUserStore();
    const userProfile = computed(() => userStore.getProfile());
    const userData = computed(() => userStore.getUser());

    const formattedDate = ref("");

    onMounted(() => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const currentDate = new Date();
      formattedDate.value = `${
        months[currentDate.getMonth()]
      } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
    });

    return {
      formattedDate,
      userProfile,
      userData
    };
  },
});
</script>